import cn from 'classnames';
import type { Duration } from 'dayjs/plugin/duration';
import { useMemo } from 'react';

import { QuestionTimer } from '@webapp/common/assets/icons';
import { CssPageBlock } from '@webapp/common/components/survey-custom';
import { DURATION_FORMAT } from '@webapp/common/lib/date';

import css from './time-left.css';

export const TimeLeft: FC<{
    value: Duration;
    className?: string;
    color?: string;
    borderRadius?: string;
}> = ({ borderRadius, className, color, value }) => {
    const time = value.format(DURATION_FORMAT);
    const style = useMemo(() => ({ color, borderRadius }), [borderRadius, color]);
    return (
        <span className={cn(CssPageBlock.QUESTION_TIMER, css.timer, className)} style={style}>
            <QuestionTimer />
            <span>{time}</span>
        </span>
    );
};
